import { render, staticRenderFns } from "./PanelDiamondConfig.vue?vue&type=template&id=644c573b&scoped=true&"
import script from "./PanelDiamondConfig.vue?vue&type=script&lang=js&"
export * from "./PanelDiamondConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644c573b",
  null
  
)

export default component.exports